module.exports = __webpack_public_path__ + "img/preview.3f79c6ef.png";